/* @sravni/react-design-system version 0.2.65 */
import { __assign } from 'tslib';

var CONTENT_SIZES = {
    S16: 16,
    S20: 20,
    S24: 24,
    S28: 28,
};
var CONTAINER_SIZES = {
    S36: 36,
    S44: 44,
    S52: 52,
    S60: 60,
};
var FONT_SIZES = {
    S8: 8,
    S10: 10,
    S12: 12,
    S14: 14,
    S16: 16,
    S20: 20,
};
var STAR_SIZES = __assign(__assign({}, CONTENT_SIZES), { S32: 32, S36: 36 });
var BORDER_RADIUS_SIZES = {
    S4: 4,
    S8: 8,
    S12: 12,
    S16: 16,
    S24: 24,
    S40: 40,
};

export { BORDER_RADIUS_SIZES, CONTAINER_SIZES, CONTENT_SIZES, FONT_SIZES, STAR_SIZES };
//# sourceMappingURL=sizes.js.map
